import React, {useEffect, useState} from 'react';

import { useSelector,useDispatch } from 'react-redux';
import {getActivityData, setActivitySelectData} from "../VoteActivity/store/actionCreators";
import {Container} from "./style";
import {Button, Ellipsis, Empty, NavBar, Search, Space} from "antd-mobile";
import {List,Badge} from "antd";
import {getHeaderData} from "../Header/store/actionCreators";
import {setMainTabbarData} from "../Main/store/actionCreators";
import {getUserInfoData} from "../User/store/actionCreators";
import {isNotBlank} from "../../util/StringUtil";
import myRequest from "../../request";

export default function ActivityList(props){
    let tktype = false;//不要使用State,会发生嵌套异常
    const dispatch = useDispatch();
    const  user  = useSelector((state) => state.getIn(['user', 'userInfo']));
    const  activityList  = useSelector((state) => state.getIn(['activity', 'activity']));
    const  isLoginError  = useSelector((state) => state.getIn(['user', 'isLoginError']));
    const [refreshing, setRefreshing] = useState(false);
    const [loading, setLoading] = useState(false);
    const [pageNum, setPageNum] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [height, setHeight] = useState(document.documentElement.clientHeight);

    const search = props.location.search.substring(1); //截取local,并删除第一个?号字符
    console.log('search',search)
    if (isNotBlank(search)) {
        myRequest.setRequestAuthtoken(search).then(res => {
            console.log('res', res)
            let { errcode } = res
            if (errcode === '200') {
                tktype = true;
            }
        });
    } else {
        tktype = true;
    }
    if(isLoginError&&tktype){
        props.history.push('/login');
    }
    const token = localStorage.getItem('token');


    // Similar to componentDidMount and componentDidUpdate:
    useEffect(() => {
        if(tktype||isNotBlank(token)){
            if(user=== null||user === undefined){
                dispatch( getUserInfoData())
            }
            dispatch(getActivityData());
            dispatch(setActivitySelectData({}));
            dispatch(setMainTabbarData('home'));

        }

    }, [dispatch]);

    function itemOnClick(item){
        props.history.push('/main/'+item.id);
    }
    // if(window.ReactNativeWebView) {
    //     window.ReactNativeWebView.postMessage("openLotteryPage")
    // }else{
    //     dispatch(getHeaderData({
    //         title:'抽奖',
    //         type: 0,
    //         rightType: 0,
    //         rightFun: {},
    //         path: '/creationDetail/'+creationDetail?.id
    //     }))
    //     handleFun('/iframe/lotteryPage')
    // }
    return (
        <>
            {
                window.ReactNativeWebView&&<NavBar
                    onBack={()=>{
                        window.ReactNativeWebView.postMessage("goBack")
                    }}
                >
                        <Ellipsis direction='middle' content={'活动列表'} />
                </NavBar>
            }

        <Container>
            <div className="container">

                    <img src='https://zhihuigonghui.oss-cn-beijing.aliyuncs.com/voteActivity/WechatIMG98.jpeg' style={{width: "100%"}} alt="" />
                    <div className="container2">


                        {
                            (activityList === null||activityList === undefined||activityList.length ===0)?
                                <Empty description='暂无数据' />:
                                <List
                                    loading={loading}
                                    itemLayout="horizontal"
                                    dataSource={activityList}
                                    rowKey={(item) => item.id}
                                    renderItem={item =>
                                            {
                                                let badgeText ="进行中";
                                                let badgeColor ="#ED4443";
                                                const now = new Date();
                                                if(now <new Date(item.subStartTime)){
                                                    badgeText = "未开始";
                                                    badgeColor ="#323232";
                                                }else  if(now >new Date(item.voteEndTime)){
                                                    badgeText = "已结束";
                                                    badgeColor ="#959595";
                                                }

                                                return(
                                                    <List.Item className='listItem' onClick={()=>itemOnClick(item)}>
                                                        <Badge.Ribbon text={badgeText} color={badgeColor}>
                                                            <img src={item?.listImgPath?.toImg()} className='img' alt="" />
                                                        </Badge.Ribbon>

                                                    </List.Item>
                                                )
                                            }
                                        }
                                />
                        }
                    </div>
            </div>

        </Container>
        </>
    );


}
